import { Component } from '@angular/core';

@Component({
  selector: 'signgaze-facet-container',
  templateUrl: './facet-container.component.html',
  styleUrls: ['./facet-container.component.scss'],
})
export class FacetContainerComponent {
  constructor() {}

  ngOnInit(): void {}
}
